var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['modal', _vm.overlayClass],attrs:{"id":_vm.overlayId}},[_c('div',{class:[_vm.modalContentDefaultClass, _vm.modalContentClass]},[(_vm.closeButtonVisible)?_c('button',{staticClass:"btn modal-close"},[_c('i',{staticClass:"icon-close"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal__header"}),_vm._v(" "),_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"overlay"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32dd64a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modal/BaseModal.vue
// module id = null
// module chunks = 